// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dVA3","lastUpdated":"styles_lastUpdated__3klIH","indentedBullet":"styles_indentedBullet__CU1m2"};